const en = {
  about: {
    title: 'About PROS',
    subtitle: 'PROS is a 10,000 pixel-art NFT collection designed to live entirely on Solana, with on-chain traceable edit history.',
    sections: {
      initialProject: {
        title: 'Initial project',
        body: 'The project starts with a simple idea: create a durable, verifiable pixel-art collection independent from external hosting. Every NFT exists on-chain and can evolve over time.',
      },
      architecture: {
        title: 'Architecture (concise version)',
        bullets: [
          '<strong>Frontend:</strong> Vite SPA (hash routing, mint/gallery/editor pages).',
          '<strong>Worker:</strong> Cloudflare Worker for RPC proxying, admin endpoints, webhook, and protections.',
          '<strong>On-chain:</strong> Anchor/Solana program for minting, archival, editing, and phase rules.',
          '<strong>Assets:</strong> SVG/metadata generated and synchronized through the project pipeline.',
        ],
      },
      conceptHighlights: {
        title: 'Concept highlights',
        bullets: [
          '100% on-chain collection (durability-first approach).',
          'Holder editing: the NFT can evolve through signed transactions.',
          'Time Machine: version history remains browsable.',
          'Guardian/Museum system tied to archived NFTs.',
        ],
      },
      costLandmarks: {
        title: 'Cost landmarks',
        note: 'These ranges are indicative (devnet/mainnet vary with congestion and providers).',
        bullets: [
          '<strong>User:</strong> low Solana network fees per transaction (mint/claim/edit).',
          '<strong>Operations:</strong> RPC + Worker + storage + monitoring costs.',
          '<strong>Security:</strong> organizational cost (secret rotation, incident drills, audits).',
          '<strong>Release:</strong> primary cost = E2E validation + operational quality before mainnet.',
        ],
      },
    },
    footer: {
      title: 'Why this page now?',
      body: 'Before the second devnet test, this page provides a quick reference to align technical team, ops, and community on vision, architecture, and production-readiness requirements.',
    },
  },
  nft: {
    invalidId: 'Invalid ID.',
    loadingErrorPrefix: 'Loading error:',
    notFound: 'PROS #{id} not found.',
    back: '← Back',
  },
  gallery: {
    loading: 'Loading…',
    indexLoadError: 'Error loading index.json',
    filtersTitle: 'Filters',
    reset: 'Reset',
    all: 'All',
    searchPlaceholder: 'Search #ID…',
    searchAriaLabel: 'Search',
    rarityFirst: 'Rarest first',
    mostCommon: 'Most common',
    noResults: 'No PROS found.',
  },
  nav: {
    navAriaLabel: 'Main navigation',
    logoAriaLabel: 'PROS — Back to home',
    connectWallet: 'Connect Wallet',
    menuAriaLabel: 'Menu',
    disconnect: 'Disconnect',
    disconnecting: 'Disconnecting…',
    disconnectFailed: 'Disconnect failed. Retry.',
    noWalletDetected: 'No wallet detected.',
    installPhantom: 'Install Phantom →',
    chooseWallet: 'Choose a wallet:',
    connecting: 'Connecting…',
    connectionFailed: 'Connection failed. Retry.',
    close: 'Close',
    previousAriaLabel: 'Previous',
    nextAriaLabel: 'Next',
    viewAllVersionsTitle: 'View full page for all versions',
  },
  router: {
    resolveWarn: '[Router] resolve() called without initialized appContainer',
    loadErrorPrefix: '[Router] Page load error:',
    notFoundTitle: 'Page not found:',
    backHome: '← Back home',
  },
};

function getValueByPath(obj, path) {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export function t(path, params = {}) {
  const value = getValueByPath(en, path);
  if (typeof value !== 'string') return value;
  return value.replace(/\{(\w+)\}/g, (_, token) => String(params[token] ?? `{${token}}`));
}

export { en };
